export const getFileList = async () => {
  return await fetch(`${process.env.REACT_APP_BASE_API_URL}/file/list/`)
    .then((response) => response.json())
    .then((data) => data);
};

export const getFileMetadata = async (userId) => {
  console.log(userId)
  return await fetch(`${process.env.REACT_APP_BASE_API_URL}/file/metadata?user_id=${userId}`)
    .then((response) => response.json())
    .then((data) => data);
};

export const getUser = async (user_id) => {
  return await fetch(`${process.env.REACT_APP_BASE_API_URL}/getuser?user_id=${user_id}`)
};

export const registerUser = async (requestData) => {
  const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}/user/register`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: requestData,
  })
    .then(async (response) => await response.json())
    .then((data) => data);

  return response;
};

export const logPayment = async (requestData) => {
  const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}/payment`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: requestData,
  })
    .then(async (response) => await response.json())
    .then((data) => data);

  return response;
};

export const uploadFile = async (fileData, jsonData) => {
  const formData = new FormData();

  formData.append("user_info", jsonData);
  formData.append("file", fileData.file);
  const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}/file/upload`, {
    method: "POST",
    body: formData,
  })
    .then(async (response) => await response.json())
    .then((data) => data)

  return response;
};

export const rollBack = async (userId) => {

  const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}/rollback`, {
    method: "POST",
    body: userId,
  })
    .then(async (response) => await response.json())
    .then((data) => data)

  return response;
};

function urlToFile(url, fileName, mimeType) {
  mimeType = mimeType || (url.match(/^data:([^;]+);/) || "")[1];

  return fetch(url)
    .then(function (res) {
      return res.arrayBuffer();
    })
    .then(function (buf) {
      return new File([buf], fileName, { type: mimeType });
    });
}

export const getCountries = async () => {
  return await fetch("https://restcountries.com/v3.1/all")
    .then((response) => response.json())
    .then((data) => data);
};
